import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { CartProvider } from "./context/CartContext";
import { LanguageProvider } from "./context/LanguageContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";

import Home from "./pages/Home";
import ProductPage from "./pages/ProductPage";
import KitCadrePage from "./pages/KitCadrePage";
import AccessoiresPage from "./pages/AccessoiresPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import VirementPage from "./pages/VirementPage";
import AdminPage from "./pages/AdminPage";
import CGVPage from "./pages/CGVPage";

// Remove any injected badges
const removeInjectedBadges = () => {
  const selectors = [
    '#emergent-badge',
    '[id*="emergent"]',
    'a[href*="emergent.sh"]',
    'a[href*="emergentagent"]'
  ];
  
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.remove();
    });
  });
};

function App() {
  useEffect(() => {
    // Remove badges on load
    removeInjectedBadges();
    
    // Watch for dynamically injected elements
    const observer = new MutationObserver(() => {
      removeInjectedBadges();
    });
    
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
    
    return () => observer.disconnect();
  }, []);

  return (
    <LanguageProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col">
            <Routes>
              {/* Admin has its own layout */}
              <Route path="/admin" element={<AdminPage />} />
              
              {/* Public routes with header/footer */}
              <Route
                path="*"
                element={
                  <>
                    <Header />
                    <main className="flex-1">
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/folgo" element={<ProductPage />} />
                        <Route path="/cargo" element={<ProductPage />} />
                        <Route path="/kit-cadre" element={<KitCadrePage />} />
                        <Route path="/accessoires" element={<AccessoiresPage />} />
                        <Route path="/a-propos" element={<AboutPage />} />
                        <Route path="/faq" element={<FAQPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/cgv" element={<CGVPage />} />
                        <Route path="/checkout" element={<CheckoutPage />} />
                        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                        <Route path="/checkout/virement" element={<VirementPage />} />
                      </Routes>
                    </main>
                    <Footer />
                  </>
                }
              />
            </Routes>
          </div>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
